import { Card } from "primereact/card";
import React from "react";
import "./AboutUs.css";
import { FaMobileAlt, FaRocket } from "react-icons/fa";
import { LiaUserFriendsSolid } from "react-icons/lia";
import { GrSecure } from "react-icons/gr";
function AboutUs() {
  return (
    <div className="AboutUs-section">
      <div className="aboutUs-heading">
        Unlock Efficiency and Productivity with HelloEMS.
      </div>
      <div className="AboutUs-paragraph">
        As a bootstrapped organization ourselves, Clota Technology totally feel your pain when
        you wish to spend all your productive hours into expanding business.
        HelloEMS is designed to simplify and enhance HR management for
        businesses of all sizes.
      </div>
      <Card className="AboutUs-card first-card">
        <div className="about-card-icon">
          <LiaUserFriendsSolid />
        </div>
        <div className="about-card-heading">User Friendly Interface</div>
        <div className="card-text">
          Enjoy an intuitive and accessible interface from any device and
          location, making it easy for all employees to use.HelloEMS is designed
          to simplify and enhance HR management for businesses of all sizes.
        </div>
      </Card>
      <Card className="AboutUs-card second-card">
        <div className="about-card-icon">
          <FaMobileAlt />
        </div>
        <div className="about-card-heading">
          One product for the entire employee lifecycle{" "}
        </div>
        <div className="card-text">
          Say bye-bye to multiple apps. It is a combination of Attendance,
          Leaves Management, Employees Management, Organization, And Payroll
          Management all from a single window.
        </div>
      </Card>
      <Card className="AboutUs-card third-card">
        <div className="about-card-icon">
          <FaRocket />
        </div>
        <div className="about-card-heading">
          Perfect for startups, and small, medium enterprises{" "}
        </div>
        <div className="card-text">
          HelloEMS simplifies and automates HR operations while cutting down
          excessive dependency on HR for your employees. Reduce administrative
          burden and free up your HR team to focus on strategic initiatives.
          Benefit from regular updates and enhancements based on user feedback
          and industry best practices.
        </div>
      </Card>
      <Card className="AboutUs-card forth-card">
        <div className="about-card-icon">
          <GrSecure />
        </div>
        <div className="about-card-heading">Data Security </div>
        <div className="card-text">
          Protect employee data with advanced security measures to ensure
          confidentiality and integrity.
        </div>
      </Card>
    </div>
  );
}

export default AboutUs;
